module.exports = __webpack_public_path__ + "img/noData.0059d889.jpg";